import React from 'react';
import MobileNavDropdown from './MobileNavDropdown';

const MobileNavContainer = ({ tabs, tabIndex, onChange }) => {
  if (!tabs) return null;
  const currentTab = tabs.find(tab => tab.value === tabIndex);
  return <MobileNavDropdown tabs={tabs} currentValue={currentTab} onChange={onChange} />;
};

export default MobileNavContainer;
